import { LocalizedString, PaymentProviderType, PriceInCurrency } from "../general/models";
import {
    ICloudPaymentsPaymentSettings, ICompanyInvoiceSettings,
    IOfflinePaymentSettings, ISBPTochkaPaymentSettings, IToBankCardPaymentSettings,
} from "../organizationBranches/models";
import {OrderStatus} from "../orders/models";

export enum DeliveryType {
    toTable = 'ToRestaurantTable',
    toAddress = 'ToAddress',
    //toAddressByYandexDelivery = 'ToAddressByYandexDelivery',
    takeaway = 'TakeAway',
    toVehicle = 'ToVehicle',
    insideTheRestaurant = 'InsideTheRestaurant',
    takeAwayToTime ='TakeAwayToTime'
}

export enum BadgeType {
    new = 'New',
    spicy = 'Spicy',
    verySpicy = 'VerySpicy',
    vegetarian = 'Vegetarian',
    hit = 'Hit'
}
export enum BookingBadgeType {
    new = 'New',
    profitable = 'Profitable',
    hit = 'Hit'
}

export enum CategoryListPhotosMode{
    defaultWithPhotos = "defaultWithPhotos",
    defaultNoPhotos = "defaultNoPhotos",
}

export enum MenuItemsPhotosModes{
    defaultWithPhotos = "defaultWithPhotos",
    defaultNoPhotos = "defaultNoPhotos",
    verticalWithPhotos = "verticalWithPhotos",
}

export enum ThemesIds{
    default = "default",
    expensiveBlack = "expensiveBlack",
}

export interface ThemeSettings {
    categoryListPhotosMode: CategoryListPhotosMode;
    storefrontPhotosMode: MenuItemsPhotosModes;
    themeId: ThemesIds;
    buttonsBackgroundColor: string | null;
    categoriesBackgroundColor: string | null;
}



export interface DeliveryToTableDetails {
    type: DeliveryType.toTable,
    tableId: number,
    seatId: string | null
}
export interface DeliveryToAddressDetails {
    type: DeliveryType.toAddress,
    address: string;
    streetType: string | null;
    street: string | null;
    houseType: string | null;
    house: string | null;
    buildingType: string | null;
    building: string | null;
    comment: string | null;
    coordinates: Coordinates | null;
    deliveryDetailsData: DeliveryDetailsData | null;
    flat: number | null;
    floor: number | null;
    name: string | null;
    orderDeliveryPriceOfferId: number | null;
    phoneNumber: string;
    porch: string | null;
}

export interface DeliveryTakeAwayDetails {
    type: DeliveryType.takeaway,
    phoneNumber: string;
    name: string | null;
}

export interface DeliveryDetailsTakeAwayToTime {
    type: DeliveryType.takeAwayToTime,
    name: string | null;
    phoneNumber: string;
    toHour: number | null;
    toMinute: number | null;
    date: Date | null;
}



export interface DeliveryToVehicleDetails {
    type: DeliveryType.toVehicle,
    phoneNumber: string;
    vehicleBrandName: string,
    vehicleColor: string,
    vehiclePlateNumber: string,
}
export interface DeliveryInsideTheRestaurantDetails {
    type: DeliveryType.insideTheRestaurant,
}

export interface DeliveryDetailsData {
    claimId: string | null;
    claimRequestIdVersion: number;
    version: number | null;
}

export type DeliveryDetails = DeliveryToTableDetails | DeliveryToAddressDetails |
    DeliveryTakeAwayDetails | DeliveryDetailsTakeAwayToTime | DeliveryToVehicleDetails | DeliveryInsideTheRestaurantDetails;



export enum DeliveryConditionType{
    fixedPrice = 'FixedPrice',
    //dynamicPrice = 'DynamicPrice',
    zonePrice = "ZonePrice"
}

export interface IDeliveryConditionsFixedPrice{
    type: DeliveryConditionType.fixedPrice,
    fixedDeliveryPrice: PriceInCurrency,
    freeDeliveryMinimalOrderPrice: PriceInCurrency
}

// export interface IDeliveryConditionsDynamicPrice{
//     type: DeliveryConditionType.dynamicPrice,
//     multiplier: number,
// }

export interface IDeliveryConditionsZonePrice{
    type: DeliveryConditionType.zonePrice,
    deliveryZones: DeliveryZone[]
}
export interface DeliveryZone{
    name: string | null,
    freeDeliveryMinimalOrderPrice: PriceInCurrency | null,
    fixedDeliveryPrice: PriceInCurrency | null,
    coordinates: Coordinates[]
}



export interface Coordinates {
    latitude: number;
    longitude: number;
}


export type DeliveryConditions = IDeliveryConditionsFixedPrice | IDeliveryConditionsZonePrice;

export interface MenuPhotos {
    backgroundPhotoUrl: string | null;
    logoPhotoUrl: string | null;
}


export enum ReportingFilterType{
    blacklistedTablesPublicIds = 'BlacklistedTablesPublicIds',
    whitelistedDeliveryTypes = 'WhitelistedDeliveryTypes',
    callWaiterForTable = 'CallWaiterForTable',
    whitelistedOrderStatuses = 'WhitelistedOrderStatuses'
}


export interface ReportingFilterBlacklistedTablesPublicIds {
    type: ReportingFilterType.blacklistedTablesPublicIds,
    tablesPublicIds: number[];
}

export interface ReportingFilterWhitelistedDeliveryTypes {
    deliveryTypes: DeliveryType[];
    type: ReportingFilterType.whitelistedDeliveryTypes
}

export interface ReportingFilterCallWaiterForTable {
    type: ReportingFilterType.callWaiterForTable
}
export interface ReportingFilterWhitelistedOrderStatuses {
    orderStatuses: OrderStatus[];
    type: ReportingFilterType.whitelistedOrderStatuses
}

export type ReportingFilter = ReportingFilterBlacklistedTablesPublicIds | ReportingFilterWhitelistedDeliveryTypes |
    ReportingFilterCallWaiterForTable | ReportingFilterWhitelistedOrderStatuses


export enum ReportingDestinationType{
    telegramChat = "TelegramChat",
    superInnoBotPrintServer = "SuperInnoBotPrintServer",
    iikoCloudTerminal = 'IikoCloudTerminal'
}

export interface TelegramChat {
    botId: number;
    chatId: number;
    filters: ReportingFilter[] | null;
    chatTitle: string,
    type: ReportingDestinationType.telegramChat
}

export interface SuperInnoBotPrintServer {
    apiUrl: string;
    filters: ReportingFilter[] | null;
    printerId: string;
    token: string;
    type: ReportingDestinationType.superInnoBotPrintServer
}

export interface IikoTerminal {
    terminalGroupId: string;
    filters: ReportingFilter[] | null;
    type: ReportingDestinationType.iikoCloudTerminal
}

export type ReportingDestination = SuperInnoBotPrintServer | TelegramChat | IikoTerminal;

export interface AddressDetails {
    mapsUrl: string | null;
    title: LocalizedString | null;
    region: LocalizedString
}

export interface ContactDetails {
    instagram: string | null;
    phoneNumber: string | null;
    telegram: string | null;
    websiteUrl: string | null;
    whatsApp: string | null;
}

export interface Reporting {
    destinations: ReportingDestination[];
}

export interface WorkingScheduleDaySlot {
    fromHour: number;
    fromMinute: number;
    toHour: number;
    toMinute: number;
}

export interface WorkingScheduleDay {
    isDayOff: boolean;
    slots: WorkingScheduleDaySlot[];
}

export interface WorkingSchedule {
    friday: WorkingScheduleDay;
    monday: WorkingScheduleDay;
    saturday: WorkingScheduleDay;
    sunday: WorkingScheduleDay;
    thursday: WorkingScheduleDay;
    timezoneInMinutes: number;
    tuesday: WorkingScheduleDay;
    wednesday: WorkingScheduleDay;
}


export interface MenuCategoryWorkingSchedule {
    isEnabled: boolean;
    friday: MenuCategoryWorkingScheduleDay;
    monday: MenuCategoryWorkingScheduleDay;
    saturday: MenuCategoryWorkingScheduleDay;
    sunday: MenuCategoryWorkingScheduleDay;
    thursday: MenuCategoryWorkingScheduleDay;
    tuesday: MenuCategoryWorkingScheduleDay;
    wednesday: MenuCategoryWorkingScheduleDay;
}

export interface MenuCategoryWorkingScheduleDay {
    isEnabled: boolean;
    slots: MenuCategoryWorkingScheduleDaySlot[];
}

export interface MenuCategoryWorkingScheduleDaySlot {
    fromHour: number;
    fromMinute: number;
    toHour: number;
    toMinute: number;
}

export enum FeedbackRedirectionType{
    YandexMaps = "YandexMaps",
    GoogleMaps = "GoogleMaps",
    TwoGis = "2gis",

}
export interface FeedbackRedirection {
    link: string | null;
    type: FeedbackRedirectionType
}

export enum MenuInfoMessageMediaType {
    image = "image",
    video = "video"
}

export interface MenuInfoMessageMediaItem {
    url: string;
    mediaType: MenuInfoMessageMediaType;
}

export interface MenuInfoMessage {
    isEnabled: boolean,
    title: { [key: string]: string };
    description: { [key: string]: string };
    callToAction: { [key: string]: string };
    mediaItems: MenuInfoMessageMediaItem[];
}


export interface MenuData {
    customersFeedbackRedirections: { [key: string]: FeedbackRedirection };
    externalIntegrationSettings: ExternalIntegrationSettings | null;
    addressDetails: AddressDetails;
    contactDetails: ContactDetails;
    workingSchedule: WorkingSchedule;
    name: { [key: string]: string };
    description: LocalizedString;
    photos: MenuPhotos;
    sortOrder: number;
    isPublic: boolean;
    showPhotos: boolean;
    deliverySettings:{
        [DeliveryType.toTable]?:{
            type: DeliveryType.toTable,
            isEnabled: boolean,
            canChooseSeat: boolean,
            description: LocalizedString,
            isChangeTableEnabled: boolean
        },
        [DeliveryType.toAddress]?:{
            type: DeliveryType.toAddress,
            isEnabled: boolean,
            deliveryConditions: DeliveryConditions,
            description: LocalizedString
        },
        [DeliveryType.takeaway]?: {
            type: DeliveryType.takeaway,
            isEnabled: boolean,
            description: LocalizedString
        },
        [DeliveryType.takeAwayToTime]?: {
            type: DeliveryType.takeAwayToTime,
            isEnabled: boolean,
            description: LocalizedString
        },
        [DeliveryType.toVehicle]?:{
            type: DeliveryType.toVehicle,
            isEnabled: boolean,
            description: LocalizedString
        },
        [DeliveryType.insideTheRestaurant]?:{
            type: DeliveryType.insideTheRestaurant,
            isEnabled: boolean,
            description: LocalizedString
        },
    },
    paymentSettings:{
        [PaymentProviderType.cloudpayments]?: ICloudPaymentsPaymentSettings,
        [PaymentProviderType.offline]?: IOfflinePaymentSettings
        [PaymentProviderType.toBankCard]?: IToBankCardPaymentSettings,
        [PaymentProviderType.companyInvoice]?: ICompanyInvoiceSettings,
        [PaymentProviderType.sbpTochka]?: ISBPTochkaPaymentSettings
        [PaymentProviderType.sberbank]?: ISBPTochkaPaymentSettings
    },
    reporting: Reporting;
    orderCancellationSettings: {
        autoCancelForgottenOrdersAfterSeconds: number
    }
    themeSettings: ThemeSettings;
    isFeedbackEnabled: boolean;
    isOrderCreationEnabled: boolean;
    isCallWaiterEnabled: boolean;
    isMenuEnabled: boolean;
    isPromoCodesEnabled: boolean;
    availableLanguages: MenuAvailableLanguages;
    isLoyaltyProgramEnabled: boolean;
    infoMessages: MenuInfoMessage[];
}

export interface Menu {
    data: MenuData;
    id: number;
    organizationBranchId: number;
    menuCategoriesQuantity: number,
    menuItemsQuantity: number,
    type: MenuType;
}

export enum MenuType {
    regular = "Regular",
    booking = "Booking"
}

export interface MenuCategory {
    data: MenuCategoryData;
    id: number;
    menuId: number;
    externalId?: string
}

export interface MenuCategoryData {
    name: { [key: string]: string };
    parentMenuCategoryId: number | null;
    workingSchedule: MenuCategoryWorkingSchedule;
    sortOrder: number;
    isInStopList: boolean;
    categoryCookingTime: CookingTime;
}

export interface MenuBookingCategory {
    data: MenuBookingCategoryData;
    externalId: string | null;
    id: number;
    isRemoved: boolean;
    menuId: number;
    organizationBranchId: number;
}

export interface MenuBookingCategoryData {
    isInStopList: boolean;
    name: { [key: string]: string };
    sortOrder: number;
}

// export interface BookingItemBadge {
//     isEnabled: boolean;
//     type: string;
// }

export type BookingScheduleSettings = WithinDayByStepBookingScheduleSettings;

export enum BookingScheduleSettingsType {
    withinDayByStep = "WithinDayByStep"
}

export interface WithinDayByStepBookingScheduleSettings {
    type: BookingScheduleSettingsType.withinDayByStep
    step: number;
    fromHour: number;
    fromMinute: number;
    toHour: number;
    toMinute: number;
}





export interface MenuBookingItemSuggestion {
    menuId: number;
    menuItemId: number;
    sortOrder: number;
}

export interface MenuBookingItemData {
    amount: number;
    badges: BookingBadgesData;
    bookingScheduleSettings: BookingScheduleSettings;
    description: { [key: string]: string };
    isInStopList: boolean;
    media: MediaItems[];
    menuBookingCategoryId: number;
    menuBookingItemSuggestions: MenuBookingItemSuggestion[];
    menuItemModifierSets: MenuItemModifierSetDescriptor[];
    name: { [key: string]: string };
    sellPrice: PriceInCurrency;
    sortOrder: number;
}

export interface MenuItemData {
    badges: BadgesData;
    description: { [key: string]: string };
    isInStopList: boolean;
    menuCategoryId: number;
    menuItemModifierSets: MenuItemModifierDescriptor[];
    name: { [key: string]: string };
    participatesInPromotions: boolean;
    photosUrls: string[];
    productId: number;
    sellPrice: PriceInCurrency;
    oldPrice?: PriceInCurrency;
    sortOrder: number;
    inputProductAmountNetto: number;
    outputProductAmountNetto: number | null;
    manufactureId: number | null;
    stopListSettings: StopListSettings | null;
    workingSchedule: MenuItemWorkingSchedule;
    cookingTimeFromCategory: boolean;
    itemCookingTime: CookingTime;
    media: MediaItems[];
    caloriesSettings: MenuItemCaloriesSettings;
    weightSettings: MenuItemWeightSettings;
    arCodeLink: string | null;
    arCodeImage: string | null;
    supplierLogoUrl: string | null;
}

export interface MenuItemCaloriesSettings {
    calories: number | null;
    carbohydrates: number | null;
    fats: number | null;
    proteins: number | null;
}

export interface MenuItemWeightSettings {
    measurement: string | null;
    value: string | null;
}

export interface MediaItems {
    preview: string;
    previewHighRes: string;
    regular: string;
    regularHighRes: string;
    source: string;
    sourceId: string;
}

// export interface MenuItemMedia {
//     preview: string;
//     previewHighRes: string;
//     regular: string;
//     regularHighRes: string;
//     source: string;
// }


export enum MediaType{
    source = "source",
    preview = "preview",
    regular = "regular",
    qr = "qr",
    all = "all"
}

export interface MenuBookingItem {
    data: MenuBookingItemData;
    externalId: string | null;
    id: number;
    isRemoved: boolean;
    menuId: number;
    organizationBranchId: number;
}


export interface StopListSettings {
    finishesAt: Date | null;
    startsAt: Date | null;
}

export interface MenuItem {
    data: MenuItemData;
    id: number;
    isRemoved: boolean;
    menuId: number;
    organizationBranchId: number;
    externalId?: string
}

export interface MenuItemModifierSetDescriptor {
    menuItemModifierSetId: number;
    sortOrder: number;
}


export interface CookingTime {
    fromTime: number | null,
    toTime: number | null
}



export interface MenuItemModifierDescriptor {
    menuItemModifierSetId: number;
    sortOrder: number;
}

export interface BadgeDetails{
    isEnabled: boolean;
    type: BadgeType;
}

export interface BookingBadgeDetails{
    isEnabled: boolean;
    type: BookingBadgeType;
}

export interface BadgesData{
    [BadgeType.new]: BadgeDetails;
    [BadgeType.spicy]: BadgeDetails;
    [BadgeType.verySpicy]: BadgeDetails;
    [BadgeType.vegetarian]: BadgeDetails;
    [BadgeType.hit]: BadgeDetails;
}

export interface BookingBadgesData{
    [BookingBadgeType.new]: BookingBadgeDetails;
    [BookingBadgeType.profitable]: BookingBadgeDetails;
    [BookingBadgeType.hit]: BookingBadgeDetails;
}


export   interface StopListSettings {
    finishesAt: Date | null;
    startsAt: Date | null;
}


export interface MenuItemWorkingScheduleDaySlot {
    fromHour: number;
    fromMinute: number;
    toHour: number;
    toMinute: number;
}

export interface MenuItemWorkingScheduleDay {
    isEnabled: boolean;
    slots: MenuItemWorkingScheduleDaySlot[];
}

export interface MenuItemWorkingSchedule {
    friday: MenuItemWorkingScheduleDay;
    isEnabled: boolean;
    monday: MenuItemWorkingScheduleDay;
    saturday: MenuItemWorkingScheduleDay;
    sunday: MenuItemWorkingScheduleDay;
    thursday: MenuItemWorkingScheduleDay;
    tuesday: MenuItemWorkingScheduleDay;
    wednesday: MenuItemWorkingScheduleDay;
}



export interface MenuItemModifierData {
    name: { [key: string]: string };
    photosUrls: string[];
    productId: number;
    sellPrice: PriceInCurrency;
    isInStopList: boolean;
    inputProductAmountNetto: number;
    outputProductAmountNetto: number | null;
    manufactureId: number | null;
}

export interface MenuItemModifier {
    data: MenuItemModifierData;
    id: string,
    externalId: string | null
}

export interface MenuItemModifierSetData {
    modifiers: MenuItemModifier[];
    name: { [key: string]: string };
    type: ModifiersSetType;
}

export interface MenuItemModifierSetChooseOneData extends MenuItemModifierSetData {
    type: ModifiersSetType.ChooseOne,
    isRequired: boolean;
}

export interface MenuItemModifierSetChooseManyData extends MenuItemModifierSetData {
    type: ModifiersSetType.ChooseMany,
    maxCountTotalChosen: number,
    minCountTotalChosen: number;
}


export interface MenuItemModifierSet {
    data: MenuItemModifierSetChooseOneData | MenuItemModifierSetChooseManyData;
    id: number;
    isRemoved: boolean;
    organizationBranchId: number;
    externalId: string | null,
    externalSettings: ExternalModifierSettings | null
}

export interface TestOrder {
    menuId: number,
    isCreateTestOrder: boolean
}



export enum ModifiersSetType{
    ChooseMany = 'ChooseMany',
    ChooseOne = 'ChooseOne'
}

export const steps = {
    createMenu: {
        title: "Создать меню",
        description: "В меню находятся все ваши позиции, настройки доставки и оплаты.",
        visible: true,
        isChecked: false
    },
    createCategory: {
        title: "Создать категорию",
        description: "Категории позволяют группировать позиции по типам. Например, кофе, паста или пицца.",
        visible: true,
        isChecked: false
    },
    addPosition: {
        title: "Добавить позиции в категорию",
        description: "Позиция содержит описание, название, стоимость и фотографию. Всю эту информацию видят ваши клиенты.",
        visible: true,
        isChecked: false
    },
    plugTelegramChat: {
        title: "Настроить уведомления о новых заказах",
        description: "Уведомления о новых заказах приходят вам в группу в Telegram, чтобы вы ничего не пропустили. В этой группе все ваши сотрудники будут получать уведомления о заказах.",
        visible: true,
        isChecked: false
    },
    customizeDeliveryMethods: {
        title: "Настроить способы доставки",
        description: "Укажите какие заказы могут делать ваши гости: заказы к столику, заказы на доставку или на вынос.",
        visible: true,
        isChecked: false
    },
    createLinkToMenu: {
        title: "Создать ссылку на меню",
        description: "Ваше меню будет доступно по этой ссылке. Ее можно разместить на сайте, на картах, в Instagram и любых других местах.",
        visible: true,
        isChecked: false
    },
    createTables: {
        title: "Создать столы",
        description: "Добавьте столы внутри вашего заведения, чтобы гости во время заказа могли их выбрать, а официанты знали за какой столик нести заказ.",
        visible: true,
        isChecked: false
    },
    loadQrLabelsForTable: {
        title: "Скачать QR-метки для каждого стола",
        description: "Для каждого стола будет уникальная наклейка. Ваши гости наводят на нее камеру, и у них автоматически открывается ваше меню.",
        visible: true,
        isChecked: false
    },
    createTestOrder: {
        title: "Сделать тестовый заказ",
        description: "Откройте ваше меню и сделайте тестовый заказ, чтобы убедиться, что все настроено верно.",
        visible: true,
        isChecked: false
    }
};


export interface QRCodesURLData {
    menuAlias: string;
}

export interface QRCodesURL {
    data: QRCodesURLData;
    lastDownloadedAt: Date | null;
    url: string;
    urlGeneratedAt: Date;
}

export interface MenuWithExtraData {
    isRemoved: boolean;
    data: MenuData;
    id: number;
    menuCategoriesQuantity: number;
    menuItemsQuantity: number;
    organizationBranchId: number;
    qrCodesURLs: QRCodesURL[];
    aliasesQuantity: number;
    ordersQuantity: number;
    type: MenuType;
}


export enum ExternalIntegrationType{
    iikoCloud = 'IikoCloud'
}

export interface ExternalMenuIntegrationData {
    type: ExternalIntegrationType;
    apiLogin: string,
    iikoOrganizationId: string
}



export interface ExternalMenuIntegrationDescriptor {
    id: number;
    type: ExternalIntegrationType;
}

export interface ExternalIntegrationSettings {
    descriptor: ExternalMenuIntegrationDescriptor;
    isEnabled: boolean;
}



export interface ExternalMenuItem {
    description: { [key: string]: string };
    id: string;
    price: PriceInCurrency;
    title: { [key: string]: string };
}

export interface MenuAvailableLanguages {
    zh: MenuAvailableLanguageSettings;
    en: MenuAvailableLanguageSettings;
    it: MenuAvailableLanguageSettings;
    ru: MenuAvailableLanguageSettings;
}

export enum MenuAvailableLanguagesType {
    zh = 'zh',
    en = 'en',
    it = 'it',
    ru = 'ru'
}

export interface MenuAvailableLanguageSettings {
    isEnabled: boolean;
}


export enum IIkoModifierSetType{
    priceSize = 'PriceSize',
    modifiers = 'Modifiers',
    groupModifiers = 'GroupModifiers',
}
export interface ExternalModifierSettings {
    integrationType: ExternalIntegrationType;
    type: IIkoModifierSetType;
    isCommonCompoundModifier: boolean;
}


